export default "__VITE_ASSET__Ca9gRo8q__"